import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {ssoSignIn} from "../../reducers/auth";
import {useDispatch} from "react-redux";

const SsoSignIn: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const getToken = async () => {
      try {
        dispatch(ssoSignIn());
        setTimeout(() => navigate('/'), 2000);
      } catch (error) {
        console.error('Failed to retrieve JWT', error);
        navigate('/sign-in');
        // Handle the error appropriately, possibly redirect to an error page
      }
    };

    getToken();
  }, [navigate]);

  return (
      <div className="LoginTable">
          <div className="LoginCell">
              <br/>
          </div>
      </div>)
};

export default SsoSignIn;
